<app-autocomplete-field
  [label]="label()"
  [description]="description()"
  [placeholder]="placeholder()"
  [formControl]="control"
  [choiceProvider]="choiceProvider"
  [valueLabel]="valueLabel">
</app-autocomplete-field>
